export const MeetingMealStatus = {
  Pending: 0,
  Paid: 1,
  Cancelled: 2,
  Failed: 3,
};

export const MeetingMealStatusNames = {
  0: 'Beklemede',
  1: 'Ödendi',
  2: 'İptal Edildi',
  3: 'Başarısız',
};

export const MeetingMealDebtType = {
  BulkMonth: 0,
  MemberAttend: 1,
  Spouse: 2,
  Guest: 3,
};

export const MeetingMealDebtTypeNames = {
  0: 'Toplu Aylık',
  1: 'Katılım / Manuel',
  2: 'Eş',
  3: 'Misafir',
};

export const LogoPostStatusNames = {
  0: 'Gönderilmedi',
  1: "Logo'ya gönderildi",
  2: 'Logo atlandı',
  3: 'Logo başarısız',
};

export const BULK_MEALS_JOB_STORAGE_KEY = 'meetingMealsBulkCreateJobId';

export const canCancelMeetingMeal = (status) => status === MeetingMealStatus.Pending;

export const getMeetingMealStatusChipSx = (status) => {
  switch (status) {
    case MeetingMealStatus.Paid:
      return { backgroundColor: '#DFFFEA', color: '#17C653' };
    case MeetingMealStatus.Cancelled:
      return { backgroundColor: '#F5F5F5', color: '#666666' };
    case MeetingMealStatus.Failed:
      return { backgroundColor: '#FFEEF3', color: '#F8285A' };
    default:
      return { backgroundColor: '#FFF4E6', color: '#FF9800' };
  }
};

export const getDebtTypeChipSx = () => ({
  backgroundColor: '#E7EDF4',
  color: '#0E4D94',
});
